module.exports = __webpack_public_path__ + "img/edit_icon.3a533780.svg";